import { render, staticRenderFns } from "./NormalInvoice.vue?vue&type=template&id=67b6e1da&"
import script from "./NormalInvoice.vue?vue&type=script&lang=js&"
export * from "./NormalInvoice.vue?vue&type=script&lang=js&"
import style0 from "./NormalInvoice.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports